export function isMobileDevice(): boolean {
    const uaData = (
        navigator as Navigator & {
            userAgentData?: { mobile?: boolean };
        }
    ).userAgentData;

    if (uaData?.mobile !== undefined) {
        return uaData.mobile;
    }

    // Fallback
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
}
